// extracted by mini-css-extract-plugin
export default {"loader":"loader_loader__M-FUL","arrow":"loader_arrow__FbStr","move":"loader_move__H6v-n"};